// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ADDED: Fixed dialog host fills open() height/width (stable size, no auto-shrink glitch). */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.custom-rules-header {
  flex: 0 0 auto;
  min-height: 2.5rem;
  height: 7%;
  background-color: #17A2B8;
  color: white;
  display: flex;
  align-items: center;
  padding-left: 1%;
}

.header {
  width: 97%;
  font-size: 14px;
  font-weight: bold;
}

.custom-rules-body {
  flex: 1 1 auto;
  height: 83%;
  overflow: auto;
  min-height: 0;
}

/* ADDED: Keep Method Type / params fixed while DateToMatch format panel is open. */
.custom-rules-body.format-help-open {
  overflow: hidden;
}

.custom-rules-footer {
  flex: 0 0 auto;
  display: flex;
  height: 10%;
  min-height: 3rem;
  justify-content: flex-end;
  align-items: center;
}

.parameters {
  height: auto;
}

.method-type-rule-name {
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #E8FCFF;
  padding: 1%;
  border-bottom: 1px solid #17A2B8;
}

.select-methodname {
  width: 98%;
  margin: 1%;
}

.field {
  padding: 1%;
}

/* ADDED: All methods — 2 equal columns per row (Lookup Type|ID, Date Locator|Operator, etc.). */
.method-params-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5% 1%;
  box-sizing: border-box;
  width: 100%;
}

.method-params-grid .field {
  padding: 0.25%;
  box-sizing: border-box;
}

.method-params-grid .param-half {
  flex: 1 1 calc(50% - 0.5rem);
  min-width: 12rem;
  max-width: calc(50% - 0.25rem);
  box-sizing: border-box;
}

.method-params-grid .mat-mdc-form-field,
.method-params-grid .mat-form-field {
  width: 100%;
}

/* EXISTING (commented): ValidateDate 3-col applied from method name alone — caused Lookup 3-in-a-row glitch.
.validate-date-params .param-xpath { flex: 1 1 38%; }
...
*/
/* ADDED: Old ValidateDate one-row (Date Locator | Operator | DateToMatch).
   Only when .validate-date-params is set via isValidateDateParamLayout() (params length === 3). */
.validate-date-params .param-xpath {
  flex: 1 1 38%;
  min-width: 11rem;
  max-width: none;
}

.validate-date-params .param-operator {
  flex: 0 1 12rem;
  min-width: 10rem;
  max-width: 14rem;
}

.validate-date-params .param-date {
  flex: 1 1 34%;
  min-width: 11rem;
  max-width: none;
}

/* ADDED: DateToMatch format info icon + inline panel (dialog tooltip flickered / clipped). */
.date-to-match-field-wrap {
  position: relative;
  overflow: visible;
}

.date-to-match-field-wrap .mat-mdc-form-field,
.date-to-match-field-wrap .mat-form-field {
  width: 100%;
}

.date-to-match-info-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #17A2B8;
  cursor: pointer;
  margin-right: 0.15rem;
}

.date-to-match-help-panel {
  position: absolute;
  top: 2.45rem;
  right: 0.25rem;
  z-index: 30;
  width: 21.5rem;
  max-width: calc(100vw - 2rem);
  /* Keep the full panel (including Time) above the footer; scroll inside. */
  max-height: min(10rem, 28vh);
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 0.45rem 0.7rem 0.7rem;
  background: #fff;
  color: #222;
  border: 1px solid #cfe8ee;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
  font-size: 12px;
  line-height: 1.35;
  box-sizing: border-box;
}

.date-to-match-help-panel .help-heading {
  font-weight: 600;
  color: #17A2B8;
  margin-bottom: 0.2rem;
}

.date-to-match-help-panel .help-heading + .help-row {
  margin-top: 0;
}

.date-to-match-help-panel .help-row + .help-heading {
  margin-top: 0.4rem;
  padding-top: 0.3rem;
  border-top: 1px solid #e4f1f4;
}

.date-to-match-help-panel .help-row {
  display: flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin-top: 0.1rem;
}

.date-to-match-help-panel .help-row:last-child {
  margin-bottom: 0.15rem;
  padding-bottom: 0.1rem;
}

.date-to-match-help-panel .help-label {
  flex: 0 0 4.6rem;
  color: #555;
}

.date-to-match-help-panel .help-value {
  flex: 1 1 auto;
  min-width: 0;
  font-family: Consolas, "Courier New", monospace;
  color: #111;
  white-space: pre-line;
}

.rule-name-field {
  width: 98%;
  margin: 1%;
}

:host ::ng-deep .mat-mdc-form-field {
  background-color: #fff !important;
}
:host ::ng-deep .mat-mdc-autocomplete-panel {
  background-color: #fff !important;
}
:host ::ng-deep .mat-mdc-form-field-infix {
  min-height: 2.5rem;
}
:host ::ng-deep .method-params-grid .mat-mdc-form-field-subscript-wrapper,
:host ::ng-deep .method-type-rule-name .mat-mdc-form-field-subscript-wrapper {
  height: 1em;
  margin-top: 0.15rem;
}

/* ADDED: Fixed-size dialog panel (matches open height/width); padding removed. */
::ng-deep .custom-rules-dialog .mat-mdc-dialog-container,
::ng-deep .custom-rules-dialog.mat-mdc-dialog-container {
  padding: 0 !important;
  overflow: hidden;
}

::ng-deep .custom-rules-dialog .mat-mdc-dialog-surface,
::ng-deep .custom-rules-dialog .mdc-dialog__surface {
  height: 100% !important;
  overflow: hidden;
}

/* mat-select — non-blocking backdrop while panel is open (same as create-rules / routing) */
::ng-deep body.routing-mat-select-open .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  pointer-events: none !important;
}

::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {
  z-index: 10001 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/rule-config-component/custom-rules/custom-rules.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,6FAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAEJ;;AACA;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,UAAA;EACA,eAAA;EACA,iBAAA;AAEJ;;AACA;EACI,cAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;AAEJ;;AAAA,mFAAA;AACA;EACI,gBAAA;AAGJ;;AADA;EACI,cAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAIJ;;AAFA;EACK,YAAA;AAKL;;AAHA;EACI,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,gCAAA;AAMJ;;AAJA;EACI,UAAA;EACA,UAAA;AAOJ;;AALA;EACI,WAAA;AAQJ;;AALA,gGAAA;AACA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AAQJ;;AANA;EACI,cAAA;EACA,sBAAA;AASJ;;AAPA;EACI,4BAAA;EACA,gBAAA;EACA,8BAAA;EACA,sBAAA;AAUJ;;AARA;;EAEI,WAAA;AAWJ;;AARA;;;CAAA;AAKA;kGAAA;AAEA;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AAUJ;;AARA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AAWJ;;AATA;EACI,aAAA;EACA,gBAAA;EACA,eAAA;AAYJ;;AATA,6FAAA;AACA;EACI,kBAAA;EACA,iBAAA;AAYJ;;AAVA;;EAEI,WAAA;AAaJ;;AAXA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;AAcJ;;AAZA;EACI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,6BAAA;EACA,0EAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4BAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAeJ;;AAbA;EACI,gBAAA;EACA,cAAA;EACA,qBAAA;AAgBJ;;AAdA;EACI,aAAA;AAiBJ;;AAfA;EACI,kBAAA;EACA,mBAAA;EACA,6BAAA;AAkBJ;;AAhBA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AAmBJ;;AAjBA;EACI,sBAAA;EACA,sBAAA;AAoBJ;;AAlBA;EACI,gBAAA;EACA,WAAA;AAqBJ;;AAnBA;EACI,cAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;EACA,qBAAA;AAsBJ;;AAnBA;EACI,UAAA;EACA,UAAA;AAsBJ;;AAlBI;EACI,iCAAA;AAqBR;AAlBI;EACI,iCAAA;AAoBR;AAjBI;EACI,kBAAA;AAmBR;AAhBI;;EAEI,WAAA;EACA,mBAAA;AAkBR;;AAdA,iFAAA;AACA;;EAEI,qBAAA;EACA,gBAAA;AAiBJ;;AAdA;;EAEI,uBAAA;EACA,gBAAA;AAiBJ;;AAdA,4FAAA;AACA;EAEI,+BAAA;AAgBJ;;AAbA;EACI,yBAAA;AAgBJ","sourcesContent":["/* ADDED: Fixed dialog host fills open() height/width (stable size, no auto-shrink glitch). */\r\n:host {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.custom-rules-header {\r\n    flex: 0 0 auto;\r\n    min-height: 2.5rem;\r\n    height: 7%;\r\n    background-color: #17A2B8;\r\n    color: white;\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 1%;\r\n}\r\n\r\n.header {\r\n    width: 97%;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n}\r\n\r\n.custom-rules-body{\r\n    flex: 1 1 auto;\r\n    height: 83%;\r\n    overflow: auto;\r\n    min-height: 0;\r\n}\r\n/* ADDED: Keep Method Type / params fixed while DateToMatch format panel is open. */\r\n.custom-rules-body.format-help-open {\r\n    overflow: hidden;\r\n}\r\n.custom-rules-footer{\r\n    flex: 0 0 auto;\r\n    display: flex;\r\n    height: 10%;\r\n    min-height: 3rem;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n}\r\n.parameters{\r\n     height: auto;\r\n}\r\n.method-type-rule-name{\r\n    height: auto;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    background-color: #E8FCFF;\r\n    padding: 1%;\r\n    border-bottom: 1px solid #17A2B8;\r\n}\r\n.select-methodname{\r\n    width: 98%;\r\n    margin: 1%;\r\n}\r\n.field{\r\n    padding: 1%;\r\n}\r\n\r\n/* ADDED: All methods — 2 equal columns per row (Lookup Type|ID, Date Locator|Operator, etc.). */\r\n.method-params-grid {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n    padding: 0.5% 1%;\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n}\r\n.method-params-grid .field {\r\n    padding: 0.25%;\r\n    box-sizing: border-box;\r\n}\r\n.method-params-grid .param-half {\r\n    flex: 1 1 calc(50% - 0.5rem);\r\n    min-width: 12rem;\r\n    max-width: calc(50% - 0.25rem);\r\n    box-sizing: border-box;\r\n}\r\n.method-params-grid .mat-mdc-form-field,\r\n.method-params-grid .mat-form-field {\r\n    width: 100%;\r\n}\r\n\r\n/* EXISTING (commented): ValidateDate 3-col applied from method name alone — caused Lookup 3-in-a-row glitch.\r\n.validate-date-params .param-xpath { flex: 1 1 38%; }\r\n...\r\n*/\r\n\r\n/* ADDED: Old ValidateDate one-row (Date Locator | Operator | DateToMatch).\r\n   Only when .validate-date-params is set via isValidateDateParamLayout() (params length === 3). */\r\n.validate-date-params .param-xpath {\r\n    flex: 1 1 38%;\r\n    min-width: 11rem;\r\n    max-width: none;\r\n}\r\n.validate-date-params .param-operator {\r\n    flex: 0 1 12rem;\r\n    min-width: 10rem;\r\n    max-width: 14rem;\r\n}\r\n.validate-date-params .param-date {\r\n    flex: 1 1 34%;\r\n    min-width: 11rem;\r\n    max-width: none;\r\n}\r\n\r\n/* ADDED: DateToMatch format info icon + inline panel (dialog tooltip flickered / clipped). */\r\n.date-to-match-field-wrap {\r\n    position: relative;\r\n    overflow: visible;\r\n}\r\n.date-to-match-field-wrap .mat-mdc-form-field,\r\n.date-to-match-field-wrap .mat-form-field {\r\n    width: 100%;\r\n}\r\n.date-to-match-info-icon {\r\n    font-size: 18px;\r\n    width: 18px;\r\n    height: 18px;\r\n    color: #17A2B8;\r\n    cursor: pointer;\r\n    margin-right: 0.15rem;\r\n}\r\n.date-to-match-help-panel {\r\n    position: absolute;\r\n    top: 2.45rem;\r\n    right: 0.25rem;\r\n    z-index: 30;\r\n    width: 21.5rem;\r\n    max-width: calc(100vw - 2rem);\r\n    /* Keep the full panel (including Time) above the footer; scroll inside. */\r\n    max-height: min(10rem, 28vh);\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    overscroll-behavior: contain;\r\n    padding: 0.45rem 0.7rem 0.7rem;\r\n    background: #fff;\r\n    color: #222;\r\n    border: 1px solid #cfe8ee;\r\n    border-radius: 4px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);\r\n    font-size: 12px;\r\n    line-height: 1.35;\r\n    box-sizing: border-box;\r\n}\r\n.date-to-match-help-panel .help-heading {\r\n    font-weight: 600;\r\n    color: #17A2B8;\r\n    margin-bottom: 0.2rem;\r\n}\r\n.date-to-match-help-panel .help-heading + .help-row {\r\n    margin-top: 0;\r\n}\r\n.date-to-match-help-panel .help-row + .help-heading {\r\n    margin-top: 0.4rem;\r\n    padding-top: 0.3rem;\r\n    border-top: 1px solid #e4f1f4;\r\n}\r\n.date-to-match-help-panel .help-row {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 0.4rem;\r\n    margin-top: 0.1rem;\r\n}\r\n.date-to-match-help-panel .help-row:last-child {\r\n    margin-bottom: 0.15rem;\r\n    padding-bottom: 0.1rem;\r\n}\r\n.date-to-match-help-panel .help-label {\r\n    flex: 0 0 4.6rem;\r\n    color: #555;\r\n}\r\n.date-to-match-help-panel .help-value {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    font-family: Consolas, \"Courier New\", monospace;\r\n    color: #111;\r\n    white-space: pre-line;\r\n}\r\n\r\n.rule-name-field{\r\n    width: 98%;\r\n    margin:1%;\r\n}\r\n\r\n:host ::ng-deep {\r\n    .mat-mdc-form-field {\r\n        background-color: #fff !important;\r\n    }\r\n    \r\n    .mat-mdc-autocomplete-panel {\r\n        background-color: #fff !important;\r\n    }\r\n\r\n    .mat-mdc-form-field-infix {\r\n        min-height: 2.5rem;\r\n    }\r\n\r\n    .method-params-grid .mat-mdc-form-field-subscript-wrapper,\r\n    .method-type-rule-name .mat-mdc-form-field-subscript-wrapper {\r\n        height: 1em;\r\n        margin-top: 0.15rem;\r\n    }\r\n}\r\n\r\n/* ADDED: Fixed-size dialog panel (matches open height/width); padding removed. */\r\n::ng-deep .custom-rules-dialog .mat-mdc-dialog-container,\r\n::ng-deep .custom-rules-dialog.mat-mdc-dialog-container {\r\n    padding: 0 !important;\r\n    overflow: hidden;\r\n}\r\n\r\n::ng-deep .custom-rules-dialog .mat-mdc-dialog-surface,\r\n::ng-deep .custom-rules-dialog .mdc-dialog__surface {\r\n    height: 100% !important;\r\n    overflow: hidden;\r\n}\r\n\r\n/* mat-select — non-blocking backdrop while panel is open (same as create-rules / routing) */\r\n::ng-deep body.routing-mat-select-open\r\n    .cdk-overlay-backdrop.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {\r\n    pointer-events: none !important;\r\n}\r\n\r\n::ng-deep .mat-mdc-select-panel.routing-mat-select-panel {\r\n    z-index: 10001 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
